'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('search-result', {
      url: '/search/result',
      params: {searchterm: null},
      template: '<search-result></search-result>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/search/result/search-result.routes.js